/**
 * Build the absolute image URL with a cache-busting query param.
 * For locally-served files we append the server-build timestamp so the browser
 * fetches the fresh version after a redeploy, while still benefiting from
 * normal caching during a single deploy.
 */
const CACHE_BUSTER = process.env.REACT_APP_BUILD_ID || String(Date.now()).slice(0, -3); // seconds precision

export const resolveAssetUrl = (src, fallback = null) => {
  if (!src) return fallback;
  // Already absolute http(s) URL → keep as is
  if (/^https?:\/\//i.test(src)) return src;
  // Local file served by our backend
  if (src.startsWith("/api/files/")) {
    const sep = src.includes("?") ? "&" : "?";
    return `${process.env.REACT_APP_BACKEND_URL}${src}${sep}v=${CACHE_BUSTER}`;
  }
  // Relative path within /public
  return src;
};
